/**
 * Constants configuration.
 */
export const ACCEPTED_DOCUMENT_TYPES =
  '.csv, .doc, .docx, .jpg, .pdf, .xls, .xlsx, application/msword, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, text/csv'

export const ACCEPTED_FILE_EXTENSIONS = ['.csv', '.doc', '.docx', '.jpg', '.pdf', '.xls', '.xlsx']

export const CLAIM_TYPES = {
  LATE_PAYMENT: 1,
  PROCUREMENT_IRREGULARITY: 2
}

export const ERROR_REASONS = {
  FILE_VALIDATION: 'FILE_VALIDATION_ERROR',
  SOMETHING_WENT_WRONG: 'SOMETHING_WENT_WRONG_ERROR'
}

export const FILE_ERROR_CLEAR_TIMEOUT = 5000

export const MAX_MB = 20

export const SNACKBAR_CLOSE_TIMEOUT = 5000
